import {RootStore} from './RootStore';
import {SPECS} from '../../../specs';

export type ReportFedopsInteractionFn = (interaction: string, fn: () => unknown) => Promise<void>;

export type ReportFedopsFn = (rootStore: RootStore) => ReportFedopsInteractionFn;

export const createReportFedopsInteraction: ReportFedopsFn =
  (rootStore) =>
  async (interaction, fn): Promise<any> => {
    const isPanoramaEnabled = rootStore.controllerParams.flowAPI.experiments.enabled(SPECS.EnablePanoramaIntegration);
    const panoramaClient = isPanoramaEnabled ? rootStore.controllerParams.flowAPI.panoramaClient : null;
    const panoramaTransaction = panoramaClient?.transaction(interaction);

    rootStore.controllerParams.flowAPI.fedops.interactionStarted(interaction);
    panoramaTransaction?.start();

    const result = await fn();

    rootStore.controllerParams.flowAPI.fedops.interactionEnded(interaction);

    panoramaTransaction?.finish();

    return result;
  };
